import IconPiggyBank from "@assets/svg/IconPiggyBank";
import IconTimer from "@assets/svg/IconTimer";
import ScrollReveal from "@/blueprint/components/ScrollReveal/ScrollReveal";
import Section from "@/blueprint/components/Section/Section";
import Text from "@/blueprint/components/Text/Text";
import { HSA_FSA_PAYMENTS } from "@/views/hsa-fsa/hsaFsaContent";

const ICONS = {
  "piggy-bank": IconPiggyBank,
  timer: IconTimer,
} as const;

const HsaFsaPayments = ({ position }: { position: number }) => (
  <Section
    id="hsa-fsa-payments"
    position={position}
    ariaLabelledBy="hsa-fsa-payments-heading"
    className="flex flex-col items-center gap-[40px] bg-brand-white px-grid-margin py-[72px] tab:gap-[56px] tab:py-[96px] sd:gap-[64px] sd:py-[128px] d:gap-[80px]"
  >
    <ScrollReveal>
      <Text variant="h3" as="h2" className="text-center">
        <span id="hsa-fsa-payments-heading">{HSA_FSA_PAYMENTS.headline}</span>
      </Text>
    </ScrollReveal>

    <ScrollReveal className="w-full" delayMs={80}>
      <div className="flex w-full flex-col items-stretch justify-center gap-[20px] tab:flex-row tab:gap-[24px] sd:gap-[32px] d:gap-[40px]">
        {HSA_FSA_PAYMENTS.cards.map((card) => {
          const Icon = ICONS[card.icon];
          return (
            <div
              key={card.id}
              /* A fixed gap rather than Figma's space-between, which misaligns the
                 titles once the two bodies wrap to different line counts. */
              className="flex flex-col gap-[20px] rounded-l bg-surface-cream p-[20px] tab:min-h-[272px] tab:flex-1 tab:gap-[40px] tab:p-[24px] sd:w-[520px] sd:flex-none sd:gap-[50px] sd:p-[32px] d:min-h-[304px] d:p-[40px]"
            >
              <Icon className="size-[40px] shrink-0 text-content-primary tab:size-[50px]" />
              <div className="flex flex-col gap-[8px]">
                <Text variant="h5" as="h3">
                  {card.title}
                </Text>
                <Text variant="paragraph-md">{card.body}</Text>
              </div>
            </div>
          );
        })}
      </div>
    </ScrollReveal>
  </Section>
);

export default HsaFsaPayments;
